export const MEALS = ['Desayuno', 'Media mañana', 'Comida', 'Merienda', 'Cena'];
export const DEFAULT_HABITS = { meals: ['Desayuno', 'Comida', 'Cena'], fasting: 'none', start: '08:00', end: '21:00', lifestyle: 'regular', cooking: '20', likes: '', dislikes: '' };
export function normalizeHabits(value = {}) {
  return { ...DEFAULT_HABITS, ...value, meals: Array.isArray(value.meals) ? MEALS.filter(x => value.meals.includes(x)) : DEFAULT_HABITS.meals };
}
const minutes = value => /^([01]\d|2[0-3]):[0-5]\d$/.test(value) ? Number(value.slice(0, 2)) * 60 + Number(value.slice(3)) : NaN;
const clock = value => `${String(Math.floor((value % 1440) / 60)).padStart(2, '0')}:${String(value % 60).padStart(2, '0')}`;
export function buildMealPlan(habits, targets) {
  const h = normalizeHabits(habits);
  if (!h.meals.length) return { error: 'Selecciona al menos una comida.' };
  const start = minutes(h.start);
  const end = minutes(h.end);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return { error: 'Indica horarios válidos.' };
  const duration = h.fasting === 'none' ? (end - start + 1440) % 1440 : ({ '12:12': 12, '14:10': 10, '16:8': 8, '18:6': 6, '20:4': 4 }[h.fasting] || 0) * 60;
  if (!duration && h.meals.length > 1) return { error: 'Revisa la ventana de comidas: la primera y la última hora deben ser distintas.' };
  const meals = h.meals.map((name, index) => ({ name, time: clock(start + Math.round(duration * index / Math.max(1, h.meals.length - 1))), ...Object.fromEntries(['cal', 'protein', 'carbs', 'fat'].map(key => {
    const total = Math.max(0, Math.round(Number(targets[key]) || 0));
    return [key, Math.floor(total / h.meals.length) + (index < total % h.meals.length ? 1 : 0)];
  })) }));
  return { meals, end: clock(start + duration), overnight: start + duration >= 1440 };
}
